var m = require('mithril');
var prop = require('mithril/stream');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var io = require('../libs/socketio');

var discoveryLogModal = {};

discoveryLogModal.open = function (record, onDone) {
  var uid = 'bacnet-discovery-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
  var lines = prop([]);
  var objects = prop([]);
  var status = prop('running');
  var stickToBottom = true; // auto-scroll unless user scrolls up

  function push(type, msg) {
    var entry = { type: type || 'log', msg: msg || '', ts: new Date() };
    lines(lines().concat([entry]));
    try { m.redraw(); } catch (e) {}
  }

  function handler(payload) {
    if (!payload) return;
    if (payload.type === 'done') {
      // include a final line in the unified feed
      push('done', payload.msg || 'Discovery complete');
      status('done');
      io.off(uid, handler);
      if (typeof onDone === 'function') onDone();
      try { m.redraw(); } catch (e) {}
      return;
    }
    if (payload.type === 'error') {
      status('error');
      // also surface the error in the unified feed
      push('error', (payload && payload.msg) || 'An error occurred');
      try { m.redraw(); } catch (e) {}
    }
    if (payload.type === 'object' && payload.msg && typeof payload.msg === 'object') {
      var obj = payload.msg;
      // Ensure we append in order; de-dup if same index appears again
      var arr = objects();
      // Replace existing by index if present
      var replaced = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] && arr[i].index === obj.index) { arr[i] = obj; replaced = true; break; }
      }
      if (!replaced) arr = arr.concat([obj]);
      objects(arr);
      // Also push into the unified feed (as structured object entry)
      try { push('object', obj); } catch (_) {}
      try { m.redraw(); } catch (e) {}
      return;
    }
    push(payload.type, payload.msg);
  }

  io.on(uid, handler);

  modal.vm.title('Discovering BACnet Objects');
  modal.vm.body = function () {
    return m('div', [
      m('div.mb2', status() === 'running' ? 'Streaming discovery logs…' : (status() === 'done' ? 'Completed.' : 'Error.')),
      m('pre.code.ba.b--mid-gray.pa2', {
          style: { maxHeight: '65vh', overflow: 'auto' },
          oncreate: function (v) {
            try { v.dom.scrollTop = v.dom.scrollHeight; } catch (e) {}
          },
          onupdate: function (v) {
            try { if (stickToBottom) v.dom.scrollTop = v.dom.scrollHeight; } catch (e) {}
          },
          onscroll: function (e) {
            try {
              var el = e.target;
              var nearBottom = (el.scrollTop + el.clientHeight) >= (el.scrollHeight - 10);
              stickToBottom = nearBottom;
            } catch (err) {}
          }
        },
        lines().map(function (ln) {
          var t = ln.ts instanceof Date ? ln.ts : new Date(ln.ts);
          var hh = String(t.getHours()).padStart(2, '0');
          var mm = String(t.getMinutes()).padStart(2, '0');
          var ss = String(t.getSeconds()).padStart(2, '0');
          var timeStr = hh + ':' + mm + ':' + ss;
          var type = (ln.type || 'log').toUpperCase();
          var cls = (function (tp) {
            if (tp === 'ERROR') return 'dark-red';
            if (tp === 'WARN' || tp === 'WARNING') return 'gold';
            if (tp === 'INFO' || tp === 'START' || tp === 'DONE' || tp === 'OBJECT') return 'light-blue';
            return '';
          })(type);
          var text;
          if (type === 'OBJECT' && ln.msg && typeof ln.msg === 'object') {
            var o = ln.msg;
            var typeStr = (o.objectTypeName || o.objectType) + ':' + o.objectId;
            var nameStr = o.name != null ? String(o.name) : '';
            var actionStr = o.action === 'ignored' ? 'Unchanged' : o.action;
            text = (o.index + '/' + o.total) + ' ' + typeStr + (nameStr ? (' ' + nameStr) : '') + ' — ' + actionStr;
          } else {
            text = (ln.msg == null ? '' : String(ln.msg));
          }
          if (type === 'OBJECT') {
            // Keep original object line styling without timestamp/type prefix
            return m('div', { class: cls }, text);
          }
          return m('div', { class: cls }, '[' + timeStr + '] [' + type + '] ' + text);
        })
      )
    ]);
  };
  modal.vm.buttons([{ label: 'Close', class: '', func: function () { io.off(uid, handler); modal.vm.close(); } }]);
  modal.vm.open({ extrawidth: true });

  loaders.requestWithLoader({
    url: record['@id'] + '/sync/?uid=' + encodeURIComponent(uid),
    method: 'GET',
    loader: 'submit'
  }).catch(function (e) {
    push('error', String(e));
  });
};

module.exports = discoveryLogModal;
